import type { SVGProps } from 'react';

const SvgTextStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 10.5h-5.89s-.03 0-.05-.01c-.33-.11-.58-.27-.75-.45q-.24-.27-.24-.69c0-.23.07-.43.21-.61s.36-.33.65-.43c.3-.11.67-.17 1.11-.17.26 0 .55.04.85.13.31.09.61.2.89.33.27.13.49.26.66.41.15.12.33.17.52.17.29 0 .54-.11.75-.34.21-.22.31-.47.31-.74 0-.37-.18-.69-.52-.96-.39-.33-.89-.61-1.5-.82A6 6 0 0 0 12.02 6c-.75 0-1.45.13-2.07.4-.63.27-1.14.66-1.51 1.17-.38.51-.56 1.14-.56 1.86 0 .39.07.75.17 1.08H5.99c-.55 0-1 .45-1 1s.45 1 1 1h11c.55 0 1-.45 1-1s-.45-1-1-1zm-3.43 3c.09.07.18.13.25.21.17.2.25.43.25.72 0 .23-.09.43-.26.61-.19.19-.44.35-.75.46-.31.12-.66.17-1.04.17-.56 0-1.04-.08-1.42-.24s-.78-.41-1.17-.73c-.19-.15-.4-.23-.64-.23-.31 0-.57.11-.77.33a1.08 1.08 0 0 0-.18 1.27q.12.255.36.45c.56.48 1.15.82 1.77 1.01.61.19 1.3.29 2.06.29s1.44-.14 2.08-.41c.65-.28 1.17-.68 1.57-1.2.4-.53.61-1.16.61-1.88 0-.29-.03-.57-.07-.82h-2.65z"
    />
  </svg>
);
export default SvgTextStrikethrough;
